import React from 'react'

import Header from "../componets/Header";
import Footer from "../componets/Footer";
import Offer from '../componets/services/Offer'

const Service = () => {
    return (
        <>
            <div className='bs-service-page'>
                <Header />
                <Offer />
                <Footer />
            </div>
        </>
    )
}

export default Service